import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

let axiosInstance;

export function useAxiosInstance() {
  const { getAccessTokenSilently, logout } = useAuth0();

  function logoutUser() {
    localStorage.removeItem('impersonate-token');
    logout({logoutParams: { returnTo: window.location.origin }});
  }

  if (!axiosInstance) {
    axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_API_GATEWAY,
      timeout: 20000,
    });

    axiosInstance.interceptors.request.use(
      async (config) => {
        const token = await getAccessTokenSilently({cacheMode: 'cache-only'});
        if (!token) {
          logoutUser();
          return;
        }

        config.headers.Authorization = `Bearer ${token}`;

        const impersonateToken = localStorage.getItem('impersonate-token');

        config.headers['Id-Token'] = impersonateToken || 'user';
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  return { axiosInstance };
}
